import { useEffect } from 'react';

import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { DesignSidebarItem } from '../Components/DesignSidebarItem';

export const PopupDesignsSecondarySidebar: React.FC = () => {
  const { setDisplayPopupPreview, relevantPopupsDesigns } =
    useTemplateStudioState();

  useEffect(() => {
    setDisplayPopupPreview(true);
    return () => {
      setDisplayPopupPreview(false);
    };
  }, []);

  return (
    <>
      {relevantPopupsDesigns?.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="popup.selectedDesignId"
        />
      ))}
    </>
  );
};
